

export default function Button({title, type}) {
    return (
        <button 
        type={type} 
        className="btn text-4-5 text-light 
        btn-primary p-2 mt-2 rounded-1"> {title}
		</button>
    )
}